/**
 * callLogsReportApi.js — API functions for the Call Logs Report page.
 *
 * fetchCallLogsReport — runs the call logs report query (rep_type
 *   "grandstreamcalllogs"). Backend handler is getGrandstreamCallLogReport
 *   in mysql_report.py, which calls sp_getGrandstreamCallLogs.
 * fetchCallTypes — loads the att_call_types lookup for the call-type filter.
 */

import { apiFetch, postReport } from '../../../../services/api.js';

// Re-export the shared filter-options loader so the schedule drawer's
// user-recipient picker has the campus user list available.
export { fetchFilterOptions } from '../../alert-details/api/alertDetailsApi.js';


/**
 * Run the call logs report.
 *
 * The stored proc filters call_start_time BETWEEN `${start} 00:00:00` and
 * `${end} 23:59:59`, so start_date / end_date must be DATE strings
 * (yyyy-mm-dd) — NOT full datetimes.
 *
 * @param {object} opts
 * @param {number} opts.campusId
 * @param {string} opts.startDate        — yyyy-mm-dd
 * @param {string} opts.endDate          — yyyy-mm-dd
 * @param {string} opts.callTypeFilter   — comma-delimited call_type_id list ('' = all)
 * @returns {Promise<{ records: Array } | { ErrorCode: number }>}
 */
export async function fetchCallLogsReport({ campusId, startDate, endDate, callTypeFilter }) {
    const body = {
        rep_type: 'grandstreamcalllogs',
        campus_id: campusId,
        start_date: startDate,
        end_date: endDate,
        call_type_filter: callTypeFilter || '',
    };

    const res = await postReport(body, '[callLogsReportApi] fetchCallLogsReport error');
    if (res.ErrorCode) return { ErrorCode: res.ErrorCode };
    const data = res.data;

    return { records: data?.records || [] };
}

/**
 * Fetch the call-type lookup options for the report filter.
 * V1: fetchall on att_call_types.
 *
 * @returns {Promise<Array<{ call_type_id, call_type_name }>>}
 */
export function fetchCallTypes() {
    return apiFetch({
        procedure: 'fetchall',
        reqType: 'direct',
        table: 'att_call_types',
        readOnly: true,
    });
}
